/**
 * shapefile2geojson: transform shapefile (shp & dbf) to geojson.
 *
 * Copyright (c) 2015, Mathieu MAST
 * Licensed under the MIT license.
 */

'use strict';


var cp1253 = [
  [0, 0x20AC, '€', '(EURO SIGN)'],
  [1, 0x0081, '', '(<control>)'],
  [2, 0x201A, '‚', '(SINGLE LOW-9 QUOTATION MARK)'],
  [3, 0x0192, 'ƒ', '(LATIN SMALL LETTER F WITH HOOK)'],
  [4, 0x201E, '„', '(DOUBLE LOW-9 QUOTATION MARK)'],
  [5, 0x2026, '…', '(HORIZONTAL ELLIPSIS)'],
  [6, 0x2020, '†', '(DAGGER)'],
  [7, 0x2021, '‡', '(DOUBLE DAGGER)'],
  [8, 0x0088, '', '(<control>)'],
  [9, 0x2030, '‰', '(PER MILLE SIGN)'],
  [10, 0x008A, '', '(<control>)'],
  [11, 0x2039, '‹', '(SINGLE LEFT-POINTING ANGLE QUOTATION MARK)'],
  [12, 0x008C, '', '(<control>)'],
  [13, 0x008D, '', '(<control>)'],
  [14, 0x008E, '', '(<control>)'],
  [15, 0x008F, '', '(<control>)'],
  [16, 0x0090, '', '(<control>)'],
  [17, 0x2018, '‘', '(LEFT SINGLE QUOTATION MARK)'],
  [18, 0x2019, '’', '(RIGHT SINGLE QUOTATION MARK)'],
  [19, 0x201C, '“', '(LEFT DOUBLE QUOTATION MARK)'],
  [20, 0x201D, '”', '(RIGHT DOUBLE QUOTATION MARK)'],
  [21, 0x2022, '•', '(BULLET)'],
  [22, 0x2013, '–', '(EN DASH)'],
  [23, 0x2014, '—', '(EM DASH)'],
  [24, 0x0098, '', '(<control>)'],
  [25, 0x2122, '™', '(TRADE MARK SIGN)'],
  [26, 0x009A, '', '(<control>)'],
  [27, 0x203A, '›', '(SINGLE RIGHT-POINTING ANGLE QUOTATION MARK)'],
  [28, 0x009C, '', '(<control>)'],
  [29, 0x009D, '', '(<control>)'],
  [30, 0x009E, '', '(<control>)'],
  [31, 0x009F, '', '(<control>)'],
  [32, 0x00A0, '\'', '(NO-BREAK SPACE)'],
  [33, 0x0385, '΅', '(GREEK DIALYTIKA TONOS)'],
  [34, 0x0386, 'Ά', '(GREEK CAPITAL LETTER ALPHA WITH TONOS)'],
  [35, 0x00A3, '£', '(POUND SIGN)'],
  [36, 0x00A4, '¤', '(CURRENCY SIGN)'],
  [37, 0x00A5, '¥', '(YEN SIGN)'],
  [38, 0x00A6, '¦', '(BROKEN BAR)'],
  [39, 0x00A7, '§', '(SECTION SIGN)'],
  [40, 0x00A8, '¨', '(DIAERESIS)'],
  [41, 0x00A9, '©', '(COPYRIGHT SIGN)'],
  [43, 0x00AB, '«', '(LEFT-POINTING DOUBLE ANGLE QUOTATION MARK)'],
  [44, 0x00AC, '¬', '(NOT SIGN)'],
  [45, 0x00AD, '­', '(SOFT HYPHEN)'],
  [46, 0x00AE, '®', '(REGISTERED SIGN)'],
  [47, 0x2015, '―', '(HORIZONTAL BAR)'],
  [48, 0x00B0, '°', '(DEGREE SIGN)'],
  [49, 0x00B1, '±', '(PLUS-MINUS SIGN)'],
  [50, 0x00B2, '²', '(SUPERSCRIPT TWO)'],
  [51, 0x00B3, '³', '(SUPERSCRIPT THREE)'],
  [52, 0x0384, '΄', '(GREEK TONOS)'],
  [53, 0x00B5, 'µ', '(MICRO SIGN)'],
  [54, 0x00B6, '¶', '(PILCROW SIGN)'],
  [55, 0x00B7, '·', '(MIDDLE DOT)'],
  [56, 0x0388, 'Έ', '(GREEK CAPITAL LETTER EPSILON WITH TONOS)'],
  [57, 0x0389, 'Ή', '(GREEK CAPITAL LETTER ETA WITH TONOS)'],
  [58, 0x038A, 'Ί', '(GREEK CAPITAL LETTER IOTA WITH TONOS)'],
  [59, 0x00BB, '»', '(RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK)'],
  [60, 0x038C, 'Ό', '(GREEK CAPITAL LETTER OMICRON WITH TONOS)'],
  [61, 0x00BD, '½', '(VULGAR FRACTION ONE HALF)'],
  [62, 0x038E, 'Ύ', '(GREEK CAPITAL LETTER UPSILON WITH TONOS)'],
  [63, 0x038F, 'Ώ', '(GREEK CAPITAL LETTER OMEGA WITH TONOS)'],
  [64, 0x0390, 'ΐ', '(GREEK SMALL LETTER IOTA WITH DIALYTIKA AND TONOS)'],
  [65, 0x0391, 'Α', '(GREEK CAPITAL LETTER ALPHA)'],
  [66, 0x0392, 'Β', '(GREEK CAPITAL LETTER BETA)'],
  [67, 0x0393, 'Γ', '(GREEK CAPITAL LETTER GAMMA)'],
  [68, 0x0394, 'Δ', '(GREEK CAPITAL LETTER DELTA)'],
  [69, 0x0395, 'Ε', '(GREEK CAPITAL LETTER EPSILON)'],
  [70, 0x0396, 'Ζ', '(GREEK CAPITAL LETTER ZETA)'],
  [71, 0x0397, 'Η', '(GREEK CAPITAL LETTER ETA)'],
  [72, 0x0398, 'Θ', '(GREEK CAPITAL LETTER THETA)'],
  [73, 0x0399, 'Ι', '(GREEK CAPITAL LETTER IOTA)'],
  [74, 0x039A, 'Κ', '(GREEK CAPITAL LETTER KAPPA)'],
  [75, 0x039B, 'Λ', '(GREEK CAPITAL LETTER LAMDA)'],
  [76, 0x039C, 'Μ', '(GREEK CAPITAL LETTER MU)'],
  [77, 0x039D, 'Ν', '(GREEK CAPITAL LETTER NU)'],
  [78, 0x039E, 'Ξ', '(GREEK CAPITAL LETTER XI)'],
  [79, 0x039F, 'Ο', '(GREEK CAPITAL LETTER OMICRON)'],
  [80, 0x03A0, 'Π', '(GREEK CAPITAL LETTER PI)'],
  [81, 0x03A1, 'Ρ', '(GREEK CAPITAL LETTER RHO)'],
  [83, 0x03A3, 'Σ', '(GREEK CAPITAL LETTER SIGMA)'],
  [84, 0x03A4, 'Τ', '(GREEK CAPITAL LETTER TAU)'],
  [85, 0x03A5, 'Υ', '(GREEK CAPITAL LETTER UPSILON)'],
  [86, 0x03A6, 'Φ', '(GREEK CAPITAL LETTER PHI)'],
  [87, 0x03A7, 'Χ', '(GREEK CAPITAL LETTER CHI)'],
  [88, 0x03A8, 'Ψ', '(GREEK CAPITAL LETTER PSI)'],
  [89, 0x03A9, 'Ω', '(GREEK CAPITAL LETTER OMEGA)'],
  [90, 0x03AA, 'Ϊ', '(GREEK CAPITAL LETTER IOTA WITH DIALYTIKA)'],
  [91, 0x03AB, 'Ϋ', '(GREEK CAPITAL LETTER UPSILON WITH DIALYTIKA)'],
  [92, 0x03AC, 'ά', '(GREEK SMALL LETTER ALPHA WITH TONOS)'],
  [93, 0x03AD, 'έ', '(GREEK SMALL LETTER EPSILON WITH TONOS)'],
  [94, 0x03AE, 'ή', '(GREEK SMALL LETTER ETA WITH TONOS)'],
  [95, 0x03AF, 'ί', '(GREEK SMALL LETTER IOTA WITH TONOS)'],
  [96, 0x03B0, 'ΰ', '(GREEK SMALL LETTER UPSILON WITH DIALYTIKA AND TONOS)'],
  [97, 0x03B1, 'α', '(GREEK SMALL LETTER ALPHA)'],
  [98, 0x03B2, 'β', '(GREEK SMALL LETTER BETA)'],
  [99, 0x03B3, 'γ', '(GREEK SMALL LETTER GAMMA)'],
  [100, 0x03B4, 'δ', '(GREEK SMALL LETTER DELTA)'],
  [101, 0x03B5, 'ε', '(GREEK SMALL LETTER EPSILON)'],
  [102, 0x03B6, 'ζ', '(GREEK SMALL LETTER ZETA)'],
  [103, 0x03B7, 'η', '(GREEK SMALL LETTER ETA)'],
  [104, 0x03B8, 'θ', '(GREEK SMALL LETTER THETA)'],
  [105, 0x03B9, 'ι', '(GREEK SMALL LETTER IOTA)'],
  [106, 0x03BA, 'κ', '(GREEK SMALL LETTER KAPPA)'],
  [107, 0x03BB, 'λ', '(GREEK SMALL LETTER LAMDA)'],
  [108, 0x03BC, 'μ', '(GREEK SMALL LETTER MU)'],
  [109, 0x03BD, 'ν', '(GREEK SMALL LETTER NU)'],
  [110, 0x03BE, 'ξ', '(GREEK SMALL LETTER XI)'],
  [111, 0x03BF, 'ο', '(GREEK SMALL LETTER OMICRON)'],
  [112, 0x03C0, 'π', '(GREEK SMALL LETTER PI)'],
  [113, 0x03C1, 'ρ', '(GREEK SMALL LETTER RHO)'],
  [114, 0x03C2, 'ς', '(GREEK SMALL LETTER FINAL SIGMA)'],
  [115, 0x03C3, 'σ', '(GREEK SMALL LETTER SIGMA)'],
  [116, 0x03C4, 'τ', '(GREEK SMALL LETTER TAU)'],
  [117, 0x03C5, 'υ', '(GREEK SMALL LETTER UPSILON)'],
  [118, 0x03C6, 'φ', '(GREEK SMALL LETTER PHI)'],
  [119, 0x03C7, 'χ', '(GREEK SMALL LETTER CHI)'],
  [120, 0x03C8, 'ψ', '(GREEK SMALL LETTER PSI)'],
  [121, 0x03C9, 'ω', '(GREEK SMALL LETTER OMEGA)'],
  [122, 0x03CA, 'ϊ', '(GREEK SMALL LETTER IOTA WITH DIALYTIKA)'],
  [123, 0x03CB, 'ϋ', '(GREEK SMALL LETTER UPSILON WITH DIALYTIKA)'],
  [124, 0x03CC, 'ό', '(GREEK SMALL LETTER OMICRON WITH TONOS)'],
  [125, 0x03CD, 'ύ', '(GREEK SMALL LETTER UPSILON WITH TONOS)'],
  [126, 0x03CE, 'ώ', '(GREEK SMALL LETTER OMEGA WITH TONOS)']
]



var iso88597 = [
  [0, 0x20AC, '€', '(EURO SIGN)'],
  [1, 0x0081, '', '(<control>)'],
  [2, 0x201A, '‚', '(SINGLE LOW-9 QUOTATION MARK)'],
  [3, 0x0192, 'ƒ', '(LATIN SMALL LETTER F WITH HOOK)'],
  [4, 0x201E, '„', '(DOUBLE LOW-9 QUOTATION MARK)'],
  [5, 0x2026, '…', '(HORIZONTAL ELLIPSIS)'],
  [6, 0x2020, '†', '(DAGGER)'],
  [7, 0x2021, '‡', '(DOUBLE DAGGER)'],
  [8, 0x0088, '', '(<control>)'],
  [9, 0x2030, '‰', '(PER MILLE SIGN)'],
  [10, 0x008A, '', '(<control>)'],
  [11, 0x2039, '‹', '(SINGLE LEFT-POINTING ANGLE QUOTATION MARK)'],
  [12, 0x008C, '', '(<control>)'],
  [13, 0x008D, '', '(<control>)'],
  [14, 0x008E, '', '(<control>)'],
  [],
  [15, 0x008F, '', '(<control>)'],
  [16, 0x0090, '', '(<control>)'],
  [17, 0x2018, '‘', '(LEFT SINGLE QUOTATION MARK)'],
  [18, 0x2019, '’', '(RIGHT SINGLE QUOTATION MARK)'],
  [19, 0x201C, '“', '(LEFT DOUBLE QUOTATION MARK)'],
  [20, 0x201D, '”', '(RIGHT DOUBLE QUOTATION MARK)'],
  [21, 0x2022, '•', '(BULLET)'],
  [22, 0x2013, '–', '(EN DASH)'],
  [23, 0x2014, '—', '(EM DASH)'],
  [24, 0x0098, '', '(<control>)'],
  [25, 0x2122, '™', '(TRADE MARK SIGN)'],
  [26, 0x009A, '', '(<control>)'],
  [27, 0x203A, '›', '(SINGLE RIGHT-POINTING ANGLE QUOTATION MARK)'],
  [28, 0x009C, '', '(<control>)'],
  [29, 0x009D, '', '(<control>)'],
  [30, 0x009E, '', '(<control>)'],
  [31, 0x009F, '', '(<control>)'],
  [32, 0x00A0, '\'', '(NO-BREAK SPACE)'],
  [33, 0x0385, '΅', '(GREEK DIALYTIKA TONOS)'],
  [34, 0x0386, 'Ά', '(GREEK CAPITAL LETTER ALPHA WITH TONOS)'],
  [35, 0x00A3, '£', '(POUND SIGN)'],
  [36, 0x00A4, '¤', '(CURRENCY SIGN)'],
  [37, 0x00A5, '¥', '(YEN SIGN)'],
  [38, 0x00A6, '¦', '(BROKEN BAR)'],
  [39, 0x00A7, '§', '(SECTION SIGN)'],
  [40, 0x00A8, '¨', '(DIAERESIS)'],
  [41, 0x00A9, '©', '(COPYRIGHT SIGN)'],
  [43, 0x00AB, '«', '(LEFT-POINTING DOUBLE ANGLE QUOTATION MARK)'],
  [44, 0x00AC, '¬', '(NOT SIGN)'],
  [45, 0x00AD, '­', '(SOFT HYPHEN)'],
  [46, 0x00AE, '®', '(REGISTERED SIGN)'],
  [47, 0x2015, '―', '(HORIZONTAL BAR)'],
  [48, 0x00B0, '°', '(DEGREE SIGN)'],
  [49, 0x00B1, '±', '(PLUS-MINUS SIGN)'],
  [50, 0x00B2, '²', '(SUPERSCRIPT TWO)'],
  [51, 0x00B3, '³', '(SUPERSCRIPT THREE)'],
  [52, 0x0384, '΄', '(GREEK TONOS)'],
  [53, 0x00B5, 'µ', '(MICRO SIGN)'],
  [54, 0x00B6, '¶', '(PILCROW SIGN)'],
  [55, 0x00B7, '·', '(MIDDLE DOT)'],
  [56, 0x0388, 'Έ', '(GREEK CAPITAL LETTER EPSILON WITH TONOS)'],
  [57, 0x0389, 'Ή', '(GREEK CAPITAL LETTER ETA WITH TONOS)'],
  [58, 0x038A, 'Ί', '(GREEK CAPITAL LETTER IOTA WITH TONOS)'],
  [59, 0x00BB, '»', '(RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK)'],
  [60, 0x038C, 'Ό', '(GREEK CAPITAL LETTER OMICRON WITH TONOS)'],
  [61, 0x00BD, '½', '(VULGAR FRACTION ONE HALF)'],
  [62, 0x038E, 'Ύ', '(GREEK CAPITAL LETTER UPSILON WITH TONOS)'],
  [63, 0x038F, 'Ώ', '(GREEK CAPITAL LETTER OMEGA WITH TONOS)'],
  [64, 0x0390, 'ΐ', '(GREEK SMALL LETTER IOTA WITH DIALYTIKA AND TONOS)'],
  [65, 0x0391, 'Α', '(GREEK CAPITAL LETTER ALPHA)'],
  [66, 0x0392, 'Β', '(GREEK CAPITAL LETTER BETA)'],
  [67, 0x0393, 'Γ', '(GREEK CAPITAL LETTER GAMMA)'],
  [68, 0x0394, 'Δ', '(GREEK CAPITAL LETTER DELTA)'],
  [69, 0x0395, 'Ε', '(GREEK CAPITAL LETTER EPSILON)'],
  [70, 0x0396, 'Ζ', '(GREEK CAPITAL LETTER ZETA)'],
  [71, 0x0397, 'Η', '(GREEK CAPITAL LETTER ETA)'],
  [72, 0x0398, 'Θ', '(GREEK CAPITAL LETTER THETA)'],
  [73, 0x0399, 'Ι', '(GREEK CAPITAL LETTER IOTA)'],
  [74, 0x039A, 'Κ', '(GREEK CAPITAL LETTER KAPPA)'],
  [75, 0x039B, 'Λ', '(GREEK CAPITAL LETTER LAMDA)'],
  [76, 0x039C, 'Μ', '(GREEK CAPITAL LETTER MU)'],
  [77, 0x039D, 'Ν', '(GREEK CAPITAL LETTER NU)'],
  [78, 0x039E, 'Ξ', '(GREEK CAPITAL LETTER XI)'],
  [79, 0x039F, 'Ο', '(GREEK CAPITAL LETTER OMICRON)'],
  [80, 0x03A0, 'Π', '(GREEK CAPITAL LETTER PI)'],
  [81, 0x03A1, 'Ρ', '(GREEK CAPITAL LETTER RHO)'],
  [],
  [83, 0x03A3, 'Σ', '(GREEK CAPITAL LETTER SIGMA)'],
  [84, 0x03A4, 'Τ', '(GREEK CAPITAL LETTER TAU)'],
  [85, 0x03A5, 'Υ', '(GREEK CAPITAL LETTER UPSILON)'],
  [86, 0x03A6, 'Φ', '(GREEK CAPITAL LETTER PHI)'],
  [87, 0x03A7, 'Χ', '(GREEK CAPITAL LETTER CHI)'],
  [88, 0x03A8, 'Ψ', '(GREEK CAPITAL LETTER PSI)'],
  [89, 0x03A9, 'Ω', '(GREEK CAPITAL LETTER OMEGA)'],
  [90, 0x03AA, 'Ϊ', '(GREEK CAPITAL LETTER IOTA WITH DIALYTIKA)'],
  [91, 0x03AB, 'Ϋ', '(GREEK CAPITAL LETTER UPSILON WITH DIALYTIKA)'],
  [92, 0x03AC, 'ά', '(GREEK SMALL LETTER ALPHA WITH TONOS)'],
  [93, 0x03AD, 'έ', '(GREEK SMALL LETTER EPSILON WITH TONOS)'],
  [94, 0x03AE, 'ή', '(GREEK SMALL LETTER ETA WITH TONOS)'],
  [95, 0x03AF, 'ί', '(GREEK SMALL LETTER IOTA WITH TONOS)'],
  [96, 0x03B0, 'ΰ', '(GREEK SMALL LETTER UPSILON WITH DIALYTIKA AND TONOS)'],
  [97, 0x03B1, 'α', '(GREEK SMALL LETTER ALPHA)'],
  [98, 0x03B2, 'β', '(GREEK SMALL LETTER BETA)'],
  [99, 0x03B3, 'γ', '(GREEK SMALL LETTER GAMMA)'],
  [100, 0x03B4, 'δ', '(GREEK SMALL LETTER DELTA)'],
  [101, 0x03B5, 'ε', '(GREEK SMALL LETTER EPSILON)'],
  [102, 0x03B6, 'ζ', '(GREEK SMALL LETTER ZETA)'],
  [103, 0x03B7, 'η', '(GREEK SMALL LETTER ETA)'],
  [104, 0x03B8, 'θ', '(GREEK SMALL LETTER THETA)'],
  [105, 0x03B9, 'ι', '(GREEK SMALL LETTER IOTA)'],
  [106, 0x03BA, 'κ', '(GREEK SMALL LETTER KAPPA)'],
  [107, 0x03BB, 'λ', '(GREEK SMALL LETTER LAMDA)'],
  [108, 0x03BC, 'μ', '(GREEK SMALL LETTER MU)'],
  [109, 0x03BD, 'ν', '(GREEK SMALL LETTER NU)'],
  [110, 0x03BE, 'ξ', '(GREEK SMALL LETTER XI)'],
  [111, 0x03BF, 'ο', '(GREEK SMALL LETTER OMICRON)'],
  [112, 0x03C0, 'π', '(GREEK SMALL LETTER PI)'],
  [113, 0x03C1, 'ρ', '(GREEK SMALL LETTER RHO)'],
  [114, 0x03C2, 'ς', '(GREEK SMALL LETTER FINAL SIGMA)'],
  [115, 0x03C3, 'σ', '(GREEK SMALL LETTER SIGMA)'],
  [116, 0x03C4, 'τ', '(GREEK SMALL LETTER TAU)'],
  [117, 0x03C5, 'υ', '(GREEK SMALL LETTER UPSILON)'],
  [118, 0x03C6, 'φ', '(GREEK SMALL LETTER PHI)'],
  [119, 0x03C7, 'χ', '(GREEK SMALL LETTER CHI)'],
  [120, 0x03C8, 'ψ', '(GREEK SMALL LETTER PSI)'],
  [121, 0x03C9, 'ω', '(GREEK SMALL LETTER OMEGA)'],
  [122, 0x03CA, 'ϊ', '(GREEK SMALL LETTER IOTA WITH DIALYTIKA)'],
  [123, 0x03CB, 'ϋ', '(GREEK SMALL LETTER UPSILON WITH DIALYTIKA)'],
  [124, 0x03CC, 'ό', '(GREEK SMALL LETTER OMICRON WITH TONOS)'],
  [125, 0x03CD, 'ύ', '(GREEK SMALL LETTER UPSILON WITH TONOS)'],
  [126, 0x03CE, 'ώ', '(GREEK SMALL LETTER OMEGA WITH TONOS)']
]

if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  }
}

function shapefile2geojson(shpBuffer, dbfBuffer) {
  if (shpBuffer) { // } && dbfBuffer) {
    var parser = new shapefile2geojsonParser();
    parser.parseShp(shpBuffer);
    parser.parseDbf(dbfBuffer);
    parser.merge();
    return parser.geojson;
  } else {
    return new shapefile2geojsonParser();
  }
}

function shapefile2geojsonParser() { }

shapefile2geojsonParser.prototype.createDv = function (buffer) {
  if (typeof DataView === 'function' && buffer instanceof DataView || typeof jDataView === 'function' && buffer instanceof jDataView) {
    return buffer;
  } else {
    try {
      if (typeof jDataView === 'function') {
        return new jDataView(buffer);
      } else {
        if (typeof ArrayBuffer === 'function' && buffer instanceof ArrayBuffer) {
          return new DataView(buffer);
        } else {
          return new DataView(new Uint8Array(buffer).buffer);
        }
      }
    } catch (err) {
      throw new Error('Unsupported buffer');
    }
  }
};

shapefile2geojsonParser.prototype.merge = function () {
  var geojson = {};
  geojson.type = 'FeatureCollection';
  geojson.features = [];
  var i = 0;
  // var len = (this.features.length < this.propertiesArray.length) ? this.features.length : this.propertiesArray.length;
  var len = this.features.length;
  while (i < len) {
    geojson.features.push({
      'type': 'Feature',
      'geometry': this.features[i],
      'properties': this.propertiesArray[i] || {}
    });
    i++;
  }
  this.geojson = geojson;
};

shapefile2geojsonParser.prototype.parseShp = function (buffer) {
  var dv = this.createDv(buffer);
  var idx = 0;
  var fileCode = dv.getInt32(idx, false);
  idx += 6 * 4;
  var wordLength = dv.getInt32(idx, false);
  var byteLength = wordLength * 2;
  idx += 4;
  var version = dv.getInt32(idx, true);
  idx += 4;
  var shapeType = dv.getInt32(idx, true);
  idx += 4;
  var minX = dv.getFloat64(idx, true);
  var minY = dv.getFloat64(idx + 8, true);
  var maxX = dv.getFloat64(idx + 16, true);
  var maxY = dv.getFloat64(idx + 24, true);
  var minZ = dv.getFloat64(idx + 32, true);
  var maxZ = dv.getFloat64(idx + 40, true);
  var minM = dv.getFloat64(idx + 48, true);
  var maxM = dv.getFloat64(idx + 56, true);
  idx += 8 * 8;
  var features = [];
  while (idx < byteLength) {
    var feature = {};
    var number = dv.getInt32(idx, false);
    idx += 4;
    var length = dv.getInt32(idx, false);
    idx += 4;
    try {
      var type = dv.getInt32(idx, true);
      var idxFeature = idx + 4;
      var byteLen = length * 2;
      switch (type) {
        case 1:
        case 11:
        case 21:
          feature.type = 'Point';
          feature.coordinates = [
            dv.getFloat64(idxFeature, true),
            dv.getFloat64(idxFeature + 8, true)
          ];
          break;
        case 3:
        case 5:
        case 13:
        case 15:
        case 23:
        case 25:
          if (type === 3 || type === 13 || type === 23) {
            feature.type = 'MultiLineString';
          } else if (type === 5 || type === 15 || type === 25) {
            feature.type = 'Polygon';
          }
          feature.coordinates = [];
          var nbparts = dv.getInt32(idxFeature + 32, true);
          var nbpoints = dv.getInt32(idxFeature + 36, true);
          idxFeature += 40;
          var nbpartsPoint = [];
          for (var i = 0; i < nbparts; i++) {
            nbpartsPoint.push(dv.getInt32(idxFeature, true));
            idxFeature += 4;
          }
          for (var i = 0; i < nbparts; i++) {
            var idstart = nbpartsPoint[i];
            var idend = nbpoints - 1;
            if (i < nbparts - 1) {
              idend = nbpartsPoint[i + 1] - 1;
            }
            var part = [];
            for (var j = idstart; j <= idend; j++) {
              part.push([
                dv.getFloat64(idxFeature, true),
                dv.getFloat64(idxFeature + 8, true)
              ]);
              idxFeature += 16;
            }
            feature.coordinates.push(part);
          }
          break;
        case 8:
        case 18:
        case 28:
          feature.type = 'MultiPoint';
          feature.coordinates = [];
          var nbpoints = dv.getInt32(idxFeature + 32, true);
          idxFeature += 36;
          for (var i = 0; i < nbpoints; i++) {
            feature.coordinates.push([
              dv.getFloat64(idxFeature, true),
              dv.getFloat64(idxFeature + 8, true)
            ]);
            idxFeature += 16;
          }
          break;
      }
    } catch (e) { }
    idx += length * 2;
    features.push(feature);
  }
  this.features = features;
};

shapefile2geojsonParser.prototype.parseDbf = function (buffer) {
  if (buffer) {
    var dv = this.createDv(buffer);
    var idx = 4;
    var numberOfRecords = dv.getInt32(idx, true);
    idx += 28;
    var end = false;
    var fields = [];
    try {
      while (true) {
        var field = {};
        var nameArray = [];
        for (var i = 0; i < 10; i++) {
          var letter = dv.getUint8(idx);
          if (letter != 0) {
            if (letter > 127) {
              nameArray.push(iso88597[letter - 128][2]);
            } else {
              nameArray.push(String.fromCharCode(letter));
            }
          }
          idx += 1;
        }
        field.name = nameArray.join('');
        idx += 1;
        field.type = String.fromCharCode(dv.getUint8(idx));
        idx += 5;
        field.fieldLength = dv.getUint8(idx);
        idx += 16;
        fields.push(field);
        if (dv.getUint8(idx) == 0x0D) break;
      }
    } catch (err) {
      end = true;
    }
    idx += 1;
    var propertiesArray = [];
    for (var i = 0; i < numberOfRecords; i++) {
      var properties = {};
      if (!end) {
        try {
          idx += 1;
          for (var j = 0; j < fields.length; j++) {
            var charString = [];
            for (var h = 0; h < fields[j].fieldLength; h++) {
              var letter = dv.getUint8(idx);
              // // if (letter != 0) {
              if (letter > 127) {
                charString.push(iso88597[letter - 128][2]);
              } else {
                charString.push(String.fromCharCode(letter));
              }
              // }
              // charString.push(String.fromCharCode(dv.getUint8(idx)));
              idx += 1;
            }
            properties[fields[j].name] = charString.join('').trim();
          }
        } catch (err) {
          end = true;
        }
      }
      propertiesArray.push(properties);
    }
    this.propertiesArray = propertiesArray;
  } else {
    this.propertiesArray = [];
  }
};

module.exports = shapefile2geojson;
